"use client";

import { useQuery } from "@tanstack/react-query";
import { useLocale } from "next-intl";
import { fetcher } from "@/lib/http/fetcher";
import { DEFAULT_SHIPPING_SETTINGS } from "../../shared/defaults";
import type { ShippingSettings } from "../../shared/types";

export function useShippingSettings(initialData?: ShippingSettings) {
  const locale = useLocale();

  const { data, isLoading } = useQuery<ShippingSettings>({
    queryKey: ["shipping-settings", locale],
    queryFn: () => fetcher<ShippingSettings>(`/${locale}/api/shipping-settings`),
    staleTime: 60_000,
    initialData,
  });

  return {
    settings: data ?? DEFAULT_SHIPPING_SETTINGS,
    isLoading,
  };
}
